// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1djyX","productName":"Table_productName__1RrWy"};